import styles from './FlexBox.module.css';

/**
 * Helper component for FlexBox
 * @ignore
 */
export default function getClass(className) {
    return styles && styles[className] ? styles[className] : className;
}
